import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { updateGuestVisitSearchQuery } from '../../../actions/components/visit-search';

const initialState = {
  query: { q: '' }
};

const onChangeSearchQueryHandler = action => ({
  [action.toString()]: (state, { payload: query }) => set(`query`, query, state)
});

export default createReducer(initialState, {
  ...onChangeSearchQueryHandler(updateGuestVisitSearchQuery)
});
